













import Vue from 'vue';

export default Vue.extend({
  props: {
    value: Boolean,
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value);
    },
  },
});
